
import { Globe, UserX, Shield } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/AuthProvider";

export const SidebarNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user?.id) return;
      
      try {
        // The policy has been updated to allow all authenticated users to view admin_users
        const { data, error } = await supabase
          .from('admin_users')
          .select('*')
          .eq('user_id', user.id)
          .single();
        
        if (data && !error) {
          console.log("Admin user found:", data);
          setIsAdmin(true);
        } else {
          console.log("Not an admin user:", error);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error checking admin status:", error);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  // Base navigation items
  const baseNavItems = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: Globe
    },
    {
      path: '/blocked-companies',
      label: 'Blocked Companies',
      icon: UserX
    }
  ];

  // Admin navigation items
  const adminNavItems = [
    {
      path: '/admin/users',
      label: 'Admin Users',
      icon: Shield
    }
  ];

  // Combine navigation items based on admin status
  const navItems = isAdmin ? [...baseNavItems, ...adminNavItems] : baseNavItems;

  return (
    <nav className="mt-6 flex-1 px-3">
      {navItems.map(item => (
        <Link 
          key={item.path}
          to={item.path} 
          className={`flex items-center px-3 py-2 rounded-lg transition-colors mb-1 ${
            location.pathname === item.path
              ? 'text-gray-900 bg-gray-50 font-medium' 
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          }`}
        >
          <item.icon className="w-5 h-5 mr-3" />
          {item.label}
        </Link>
      ))}
    </nav>
  );
};
